/*
 * @Description:
 * @Author: 山淑兰
 * @Date: 2020-01-06 00:25:24
 * @LastEditTime : 2020-01-06 22:08:45
 * @LastEditors  : 山淑兰
 */

export default {
  /**
   * @description: 返回各类状态码
   * @param {obj} type url:需要跳转的路由
   * @param {obj} type params:tourl
   */
  redirect(url: string, params?: any) {
    try {
      const { query, path } = VUE.$route;
      if (path !== url) {
        VUE.$router.push({ path: url, query: Object.assign(query, params) });
      }
    } catch (error) {
      console.error(error);
    }
  },
  /**
   * @description: 判断是否为微信 PC 客户端浏览器
   * WindowsWechat/MacWechat 是 PC 微信 UA 专属标记，手机微信 UA 不含
   */
  isPcWechat() {
    const ua = window.navigator.userAgent.toLowerCase();
    return ua.match(/micromessenger/i) != null && ua.match(/windowswechat|macwechat/i) != null;
  },
};
